import { SuccessPayload } from 'components/widgets/invest-component/storage/invest-states'
import { atomsWithMutation } from 'jotai-tanstack-query'
import { TransactionResult, parseTransactionResult } from '../deposit-redeem-v1/utils'
import { wagmiConfig } from 'services/wallet/chains'
import { viemPublicClients } from 'services/wallet/chains'
import { convertAmountToWei } from 'utils'
import { defaultGasMultiplier, gasMultiplier } from '../deposit-redeem-v1'
import { simulateContract, writeContract } from '@wagmi/core'
import { PHTRRouterAbi } from '../../../abis/PHTRRouter'
import Big from 'big.js'
import { STAKING_ROUTER_ADDRESS } from 'app-constants'

//stake
export const [depositPHTRTransactionResponseAtom, depositPHTRTransactionRequestAtom] =
  atomsWithMutation<TransactionResult | undefined, unknown, SuccessPayload, unknown>(() => ({
    mutationKey: ['phtr-deposit-transaction'],
    mutationFn: async (props: SuccessPayload) => {
      console.log('phtr-deposit-transaction')
      const { inputCurrency, account, sellAmount, buyAmount } = props
      const publicClient = viemPublicClients[inputCurrency.chainId]
      const amount = BigInt(convertAmountToWei(sellAmount, inputCurrency.decimals).toFixed())

      //estimate gas
      const estimatedGas = await publicClient.estimateContractGas({
        account,
        address: STAKING_ROUTER_ADDRESS,
        abi: PHTRRouterAbi,
        functionName: 'stake',
        args: [amount, account],
      })

      // is scale needed
      const scaledGas =
        (estimatedGas * (gasMultiplier[inputCurrency.chainId] ?? defaultGasMultiplier)) /
        BigInt(10000)

      // prepare contract
      const stake = await simulateContract(wagmiConfig, {
        account,
        address: STAKING_ROUTER_ADDRESS,
        abi: PHTRRouterAbi,
        functionName: 'stake',
        args: [amount, account],
        gas: scaledGas,
      })
      console.log('stake: ', stake)

      const hash = await writeContract(wagmiConfig, {
        account,
        address: STAKING_ROUTER_ADDRESS,
        abi: PHTRRouterAbi,
        functionName: 'stake',
        args: [amount, account],
        gas: scaledGas,
      })

      return parseTransactionResult(hash, props, buyAmount ?? Big(0))
    },
  }))

// unstake
export const [redeemPHTRTransactionResponseAtom, redeemPHTRTransactionRequestAtom] =
  atomsWithMutation<TransactionResult | undefined, unknown, SuccessPayload, unknown>(() => ({
    mutationKey: ['phtr-unstake-transaction'],
    mutationFn: async (props: SuccessPayload) => {
      console.log('phtr-unstake-transaction')
      const { inputCurrency, account, sellAmount, buyAmount } = props
      const publicClient = viemPublicClients[inputCurrency.chainId]
      const amount = BigInt(convertAmountToWei(sellAmount, inputCurrency.decimals).toFixed())

      //estimate gas
      const estimatedGas = await publicClient.estimateContractGas({
        account,
        address: STAKING_ROUTER_ADDRESS,
        abi: PHTRRouterAbi,
        functionName: 'unstake',
        args: [amount, account],
      })

      // is scale needed
      const scaledGas =
        (estimatedGas * (gasMultiplier[inputCurrency.chainId] ?? defaultGasMultiplier)) /
        BigInt(10000)

      // prepare contract
      const unstake = await simulateContract(wagmiConfig, {
        account,
        address: STAKING_ROUTER_ADDRESS,
        abi: PHTRRouterAbi,
        functionName: 'unstake',
        args: [amount, account],
        gas: scaledGas,
      })

      console.log('unstake: ', unstake)

      const hash = await writeContract(wagmiConfig, {
        account,
        address: STAKING_ROUTER_ADDRESS,
        abi: PHTRRouterAbi,
        functionName: 'unstake',
        args: [amount, account],
        gas: scaledGas,
      })

      return parseTransactionResult(hash, props, buyAmount ?? Big(0))
    },
  }))
